module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted list",
    attrs: {
      "id": "dashNotificationReel"
    },
    on: {
      "wheel": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$parent.$parent.worldStore.notifications.length > 0),
      expression: "$parent.$parent.worldStore.notifications.length>0"
    }],
    staticClass: "ui header",
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('span', {
    staticClass: "ui violet empty circular label"
  }), _vm._v("\n    Recent Notifications:\n    "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "float": "right",
      "font-weight": "normal",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearList.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      [clear list]\n    ")])]), _vm._v(" "), _vm._l((_vm.$parent.$parent.worldStore.notifications), function(item, index) {
    return _c('a', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.openDetails(index)
        }
      }
    }, [(item.productId !== null && _vm.$parent.$parent.worldStore.products[item.productId]) ? _c('img', {
      staticClass: "ui mini image",
      attrs: {
        "src": _vm.$parent.$parent.worldStore.products[item.productId].largeImageUrl
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      class: 'header ' + item.notificationLevel
    }, [_vm._v(_vm._s(item.notificationType))]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(item.message))])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$parent.$parent.worldStore.notifications.length == 0),
      expression: "$parent.$parent.worldStore.notifications.length == 0"
    }],
    staticStyle: {
      "color": "#aaa"
    }
  }, [_vm._v("\n    Leave the site open, the latest "), _c('span', {
    staticClass: "ALERT"
  }, [_vm._v("Alerts")]), _vm._v(" "), _c('br'), _vm._v(" and "), _c('span', {
    staticClass: "NOTICE"
  }, [_vm._v("Notifications")]), _vm._v(" will appear here too.\n  ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dfee8e98!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotificationReel.vue
// module id = 818
// module chunks = 2